// ThumbCell — the Onshape thumbnail as a small image in a grid row.
//
// Alex, 2026-08-04: "Should it be also visible in the catalog, in the correct location? I
// thought we did the picture icons or whatever for that, and I don't see anything." The
// thumbnail existed, but only inside an opened panel behind a button, so a grid of 600
// families showed no pictures at all. (`item_images` — the other mechanism he remembered
// — exists as a table and has never held a row.)
//
// ⚠ STRICTLY ZERO QUOTA, AND THAT IS THE WHOLE DESIGN. This renders a thumbnail ONLY when
// one is already cached on disk, and asks a filesystem-existence endpoint to find out. It
// must never trigger a fetch: a grid renders hundreds of rows at once, so a cell that
// fetched on render would spend the year's Onshape budget in one scroll. Nothing here
// reaches Onshape — the `<img>` is mounted only after `cached.thumbnail` comes back true,
// and that response is a stat() on a file.
//
// No ref, or no cached image: renders nothing at all. An empty box on every row would be
// noise on the 568 of 610 families that have no model.

import { useEffect, useState } from 'react';
import HoverZoomImg from './HoverZoomImg.jsx';

export default function ThumbCell({ onshapeRef, size = 28 }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!onshapeRef) { setReady(false); return; }
    let alive = true;
    setReady(false);
    fetch(`/api/onshape/cached?ref=${encodeURIComponent(onshapeRef)}`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (alive && d?.thumbnail) setReady(true); })
      .catch(() => { /* unknown means don't show — never means "go and fetch it" */ });
    return () => { alive = false; };
  }, [onshapeRef]);

  if (!onshapeRef || !ready) return null;
  return (
    <HoverZoomImg
      src={`/api/onshape/thumbnail?ref=${encodeURIComponent(onshapeRef)}`}
      title="Cached Onshape thumbnail"
      style={{
        width: size, height: size, objectFit: 'contain', borderRadius: 2,
        border: '1px solid var(--th-border-subtle)', background: 'var(--th-row-even)',
        display: 'block',
      }}
    />
  );
}
